export const data = [
    {
        name: 'Spine',
        description: 'I designed and built Spine, a cosy social reading app where readers keep a virtual bookshelf, track their progress and share quotes, which they can scan straight from a photo of the page. I handled the UI/UX design, frontend and backend. I built the core app myself, then used Claude as a coding partner for new features and a security review.',
        topSkills: ["UI/UX Design", "Product Design", "Problem-solving", "Next.js", "React.js", "TypeScript", "Tailwind CSS", "Responsive Design", "MongoDB", "REST API Design", "Authentication (OAuth)", "Web Security", "Content Moderation", "Git", "GitHub", "Vercel", "AI-assisted Development"],
        languages: ['TypeScript', 'JavaScript', 'HTML', 'CSS', 'Next.js', 'React.js', 'Tailwind CSS', 'Node.js', 'Mongoose', 'MongoDB', 'NextAuth', 'Zustand', 'Google Books API', 'Tesseract.js', 'RESTful API'],
        link: 'https://spine-mocha.vercel.app/',
        image: '/images/spine.png',
        id: 1
    },
    {
        name: 'Journal App ',
        description: 'A desktop-optimized, full-stack health dashboard tracking Hydration, Sleep, Weight, and Diet. Features a "Soft Aesthetic" UI with dynamic animations and a custom "Midnight Sync" logic to provide real-time daily health snapshots.',        
        topSkills: ["React.js", 
        "Next.js 15", 
        "MongoDB", 
        "Mongoose", 
        "Tailwind CSS", 
        "NextAuth.js", 
        "UI/UX Design", 
        "Full-Stack Development", 
        "Vercel Deployment", 
        "Data Visualization", 
        "API Development"],
        languages: ['Javascript', 'HTML', 'CSS', 'RESTful API', 'Mongoose', 'Next.js', 'React.js', 'Tailwind CSS'],
        link:'https://journal-app-plum-five.vercel.app/',
        image:'/images/journalApp.png',
        id:2
    },
    {
        name: 'Bid Brick ',
        description: 'I designed and developed a platform that let people sell their properties on auction. This project was done during my last year of university. I was responsible for the frontend and backend development, as well as the UI/UX design. The access password is: Auctionmk747!',
        topSkills: ["Agile Methodology","Communication","Data Analysis", "Problem-solving", "React.js", "Node.js","HTML5","CSS3", "JavaScript","Responsive Design","MERN Stack", "Mongo DB","Git","GitHub","Netlify","Railway", "Socket.io","UI/UX Design","Wireframing",],
        languages: ['Javascript', 'HTML', 'CSS', 'RESTful API', 'Socket.io', 'Express', 'Mongoose', 'Node.js', 'React.js'],
        link:'https://bidbrick.netlify.app/',
        image:'/images/bidbrick.png',
        id:1
    },
    {
        name: 'Shangri La Petitions',
        description: 'I designed and developed a website for people from Shangri-La to create and share petitions. For further details check my GitHub profile.',
        topSkills: ["Agile Methodology","Communication","Data Analysis", "Problem-solving", "React.js", "Node.js","HTML5","CSS3", "JavaScript","Responsive Design","MERN Stack", "Mongo DB","Git","GitHub","Netlify","Heroku","UI/UX Design","Wireframing",],
        languages: ['Javascript', 'HTML', 'CSS', 'RESTful API'],
        link:'https://shangri-la-petitions-mk747.netlify.app/',
        image:'/images/shangriLa.png',
        id:2
    },
    {
        name: 'Byte Queens',
        description: 'I designed and developed the official website for Byte Queens, a tech community aimed at empowering women in STEM.',
        topSkills: ["Collaboration","Volunteering","Agile Methodology","Communication","Teamwork","Problem-solving", "React.js","HTML5","CSS3", "JavaScript","Responsive Design","Node.js","Express","MongoDB","Git","GitHub","Netlify","Heroku","UI/UX Design","Wireframing",],
        languages: ['Javascript', 'HTML', 'CSS', 'RESTful API'],
        link:'https://www.bytequeens.com/',
        image:'/images/byteQueens.png',
        id:1
    },
    {
        name: 'IBM Skillsbuild Gamification',
        description: 'A gamified version of IBM Skillsbuild group project done during second year of university',
        topSkills: ['Project Management', 'Organisation', 'Critical Thinking', 'Problem Solving', 'Requirement Analysis', 'Mongo DB', '.pug Template', 'Node.js','Leadership', 'Teamwork', 'Resolving Conflicts',
                    'Listening', 'Communication'],
        languages: ['Javascript', 'HTML', 'CSS', '.pug', 'RESTful API'],
        link:'https://github.com/mkrandhawa/IBM_SkillsBuild.git',
        image:'/images/ibm.png',
        id:2
    },
    {
        name: 'Simon Game',
        description: 'Classic Simon game created using JavaScript/JQuery.',
        topSkills: ['Project Management', 'Organisation', 'Critical Thinking', 'Problem Solving', 'Requirement Analysis', 'UI Design' ],
        languages: ['Javascript', 'HTML', 'CSS', 'JQuery'],
        link:'https://simongame-project.netlify.app/',
        image:'/images/simon.png',
        id:1
    },
    {
        name: 'Tinder for Dogs',
        description: 'Tinder-themed website for dogs made using Bootstrap with some customisation.',
        topSkills: ['Project Management', 'Organisation', 'Critical Thinking', 'Problem Solving', 'Requirement Analysis', 'UI Design' ],
        languages: ['Javascript', 'HTML', 'CSS', 'Bootstrap'],
        link:'https://tinder-dog-project.netlify.app/',
        image:'/images/tinDog.png',
        id:2
    },
    {
        name: 'Drum Kit',
        description: 'Animated Drum Kit website with sound',
        topSkills: ['Project Management', 'Organisation', 'Critical Thinking', 'Problem Solving', 'Requirement Analysis'],
        languages: ['Javascript', 'HTML', 'CSS'],
        link:'https://drumkithtml.netlify.app/',
        image:'/images/drumkit.png',
        id:1
    },    
    {
        name: 'Operations On Fractions',
        description: 'Given two pairs of numbers, print the fraction and perform basic mathematical calculation.',
        topSkills: ['Time Management', 'Problem Solving', 'Self Learning'],
        languages: ['Python'],
        link:'https://github.com/mkrandhawa/Operations_on_fractions.git',
        image:'/images/operation.png',
        id:2
    },
    {
        name: 'Hangman Solo',
        description: 'Guess the random word chosen by the system.',
        topSkills: ['Problem Solving', 'Organisation', 'Time Management', 'Reuquirement Analysis'],
        languages: ['Python'],
        link:'https://github.com/mkrandhawa/Hangman_Solo.git',
        image:'/images/hangman_solo.png',
        id:1
    },
    {
        name: 'Rock Paper Scissors User vs Computer',
        description: 'Rock Paper Scissors game where the user will play against the system',
        topSkills: ['Problem Solving', 'Critical Thinking', 'Programming'],
        languages: ['Python'],
        link:'https://github.com/mkrandhawa/Rock_Paper_Scissors_UservsComputer.git',
        image:'/images/rps_usercomp.png',
        id:2
    },
    {
        name: 'Rock Paper Scissors Computer vs Computer',
        description: 'Rock Paper Scissors game where the computer will play gainst itself.',
        topSkills: ['Problem Solving','Time Management','Requirement Analysis', 'Communication'],
        languages: ['Python'],
        link:'https://github.com/mkrandhawa/Rock_Paper_Scissors_CompvsComp.git',
        image:'/images/rps_compvscomp.png',
        id:1
    },
    {
        name: 'Arithmatic Arranger',
        description: 'Program that takes as input a series of problems and prints the result.',
        topSkills: ['Requirement Analysis', 'Problem Solving', 'Project Management'],
        languages: ['Python'],
        link:'https://github.com/mkrandhawa/Arithmetic_Arranger.git',
        image:'/images/mathOperations.png',
        id:2
    },
   
];

